/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from "../../Generated/RestClient";
import * as Views from "../../Views/LogoutPanel";
import {clientAppSettings} from "../../Models/ClientAppSettings";
import {LogoutPage, LogoutPageProps, LogoutPageState} from "../../Views/LogoutPage";

let component: React.Component<LogoutPageProps, LogoutPageState>;
let state: LogoutPageState = { items: [] };
let siteSignOutSuccess = false;   // apps and channels

function redirectOnAllSuccess(): void {
    if (siteSignOutSuccess) {
        if (window.location.protocol.indexOf('https:') == 0) {
            window.location.href = '/Identity/SignOut';
        } else {
            window.location.assign('/');
        }
    }
}

function getChannels() : Rest.Channel[] {
    //return clientAppSettings.channels.filter(ch => !!ch.DeveloperConfigLogoutUrl);
    return [];
}

function singleSignOut(): void {
    var status = {
        failureCount: 0,
        successCount: 0
    };

    const channels = getChannels();

    function onSiteSignOutSuccess(): void {
        siteSignOutSuccess = true;
        redirectOnAllSuccess();
    }
    function markPanelStatus(key: string, logoutPanelStatus: Views.LogoutPanelStatus): void {
        for (let item of state.items) {
            if (item.key === key) {
                item.status = logoutPanelStatus;
                component.setState(state);
                return;
            }
        }
    }
    function onImageLoadSuccess(e: JQueryEventObject): void {
        let $src = $(e.target);
        let tag = $src.attr('data-tag');
        markPanelStatus(tag, Views.LogoutPanelStatus.Success);
        if (++status.successCount === state.items.length) {
            onSiteSignOutSuccess();
        }
    }
    function onImageLoadFailure(e: JQueryEventObject): void {
        let $src = $(e.target);
        let tag = $src.attr('data-tag');
        markPanelStatus(tag, Views.LogoutPanelStatus.Failure);
        ++status.failureCount;
    }
    if (channels.length === 0) {
        onSiteSignOutSuccess();
    }
    else 
    {
        for (let channel of channels) {
            var $img = $(`<img data-tag=${'channel:' + channel.Id}>`);
            $img.bind("load", e => onImageLoadSuccess(e));
            $img.bind("error", e => onImageLoadFailure(e));
            $img.attr("src", channel.DeveloperConfigLogoutUrl);
        }   
    }
}

function addChannelsToState(): void {
    const channels = getChannels();
    for (let channel of channels) {
        state.items.push({
            key: 'channel:' + channel.Id,
            title: channel.Name + ' Channel',
            status: Views.LogoutPanelStatus.InProgress
        });
    }
}

export function signOut($el: JQuery): void {
    var element = React.createElement(LogoutPage, {});
    component = ReactDOM.render<LogoutPageProps, LogoutPage>(element, $el[0], () => {
        singleSignOut();
    });
    addChannelsToState();
    component.setState(state);
}




// WEBPACK FOOTER //
// ./Client/v4/Controllers/SignOut.ts